<template>
  <div class="login-body">
    <div v-if="loading" class="loading">
      <van-loading type="spinner" size="1rem" color="#0094ff" />
    </div>
    <van-popup
      class="only-register"
      v-if="$store.state.isRecord && $store.state.isRecordType == 0"
      v-model="showRegister"
      z-index="3000"
      :close-on-click-overlay="false"
    >
      <div class="login-register-body">
        <div
          style="
            font-size: 0.35rem;
            margin: 0 0 0.1rem;
            font-weight: bold;
            text-align: center;
          "
        >
          {{ $t('Login.newText1') }}
        </div>
        <div
          style="font-size: 0.38rem; text-align: center; margin-bottom: 0.35rem"
        >
          {{ $t('Login.newText2') }}
        </div>
        <div class="login-box">
          <div
            style="
              font-size: 0.35rem !important;
              color: #fff !important;
              display: block;
              margin-bottom: 0.2rem;
              text-align: center;
              font-weight: 700 !important;
            "
          >
            {{ $t('Login.newText3') }}
          </div>
          <div class="spcss" style="margin-bottom: 0.1rem">
            <div
              class="flex items-center"
              style="
                border: 0.02rem solid var(--theme-color-line);
                border-radius: 0.14rem;
                height: 0.84rem;
                overflow: hidden;
              "
            >
              <div
                slot="left"
                @click.stop="riqifanshi = !riqifanshi"
                class="icontest"
                style="
                  display: flex;
                  align-items: center;
                  color: #fff;
                  padding: 0 0.1rem 0 0.14rem;
                  height: 0.84rem;
                  border-right: 0.02rem solid var(--theme-color-line);
                  background-color: rgba(255, 255, 255, 0.08);
                "
              >
                <img
                  style="width: 0.36rem; height: 0.27rem"
                  :src="
                    require('./../../assets/icons/images/' +
                      country.name +
                      '.png')
                  "
                />
                <span style="font-size: 0.28rem; padding-left: 0.1rem">{{
                  country.code
                }}</span>
                <div
                  style="
                    border-left: 0.05rem solid transparent;
                    border-right: 0.05rem solid transparent;
                    border-top: 0.07rem solid #555;
                    margin-left: 0.1rem;
                  "
                ></div>
              </div>
              <div style="width: 100%">
                <van-field
                  v-model="formConter.phone"
                  type="number"
                  label=""
                  :placeholder="$t('Login.newText11')"
                />
              </div>
            </div>
            <div
              class="ant-select-dropdow"
              @click.stop="riqifanshi = false"
              v-if="riqifanshi"
              style="width: auto"
            >
              <div class="Conter_arrConte" style="width: auto">
                <div
                  class="icontest"
                  style="
                    display: flex;
                    align-items: center;
                    color: var(--theme-text-color-lighten);
                    width: auto;
                  "
                >
                  <img
                    style="width: 0.36rem; height: 0.27rem"
                    :src="
                      require('./../../assets/icons/images/' +
                        country.name +
                        '.png')
                    "
                  />
                  <span style="padding-left: 0.1rem; padding-right: 0.4rem">{{
                    country.full
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style="
            width: 100%;
            max-width: 9.33rem;
            height: 0.92rem;
            background: var(--theme-primary-color) !important;
            border: none;
            border-radius: 0.5rem;
            color: white;
            font-size: 0.3rem;
            font-weight: bold;
            cursor: pointer;
            text-align: center;
            line-height: 0.92rem;
          "
          @click="submit"
        >
          {{ $t('components._Prosseguir') }}
        </div>
      </div>
      <div class="QzRd3YqTnYxG8Latq8fW" @click="cancelLogin">
        <img
          class="closeIcon"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAMAAABGS8AGAAAAilBMVEUAAAD////e5Orv8vXe5Or////e5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Or////////h5+z8/f7z9ffm6/Dp7fHt8PT5+vv2+PrCEzcDAAAAJXRSTlMAYJYggoAJR6DVzbyRfHYuimpXKBlePTURrlDbxOm27OJwZaif1OMsUAAABGNJREFUWMPdmdtiojAQhlNAOSOoeK6tugRy4P1fb0lCO26DDRiv9r8Twsfkz0wSA/ovtVh6tzj8fP/4eP+M4iBdrpC93GtwJJQ1La+leNswisOgXNtQd9czpg2vNPGG4v1y/iR2lWDaVo9Ud2xv/YyxDmnqnsG77hOCOxFhC/+6znDuTsSuHdx89ZrgU5CW/nbluqutX6ZBJP1RYeN8kiEZZv2DJMr9nfbaZRL2/alZdJ3ignyIU5xvHzXaOJipVsQZaXWBG4UNi99zJuvR7LQcw00Il63xxdw2VTG02DO3dahqmuxG1Y8jw6iJY2g4V1wWH9BIFZEMmjoGLlPv302oI4eayYqLczRJKomoY/CX4wxNVI4F+bHPDpHcAk2Wp8gPcuOChQ/AnURWzx4GByEUiYNT9JQS0ds2HjSiEb1JnoDC+LABmzMCN55SIALDpVb4wn4eWSw4G0k4aR4x8b4rslAq+ky9HyOHlRFWujUiM34ELK9JI2zM0EJewyUbJVrIHuuufNpvQsT40QKB5IVsoOVsNnMRGnEDQuYh/F5S0QV9uX2rhN7QmBuQAwTWyX33osbRw6qU3nSukh5z3Hak/J/iIBut1awC8hC3mmmPlLQfLHDiiAbBQNa51R99CcL1nReOcCIZBgNZ50LEoHPHYl9pIOZLekCDHgNZ54LHoIx1QZ7758VQalUHECBrl3RtCSTYgYh5DSET2cgFkxcQfYDMZANX6dR2vi6/x455aAR5BBcFMHpiIGmJRpDNXDXt9MUW8c4VHxnII7mooN9pEXJZdwaymQvV1qoF6hPG0UQ2c5EPOfbRgfEKmcnANYHDEWAgA9cMBivswboVRzF4W3srYPD4SUs3+8G7iqw4qwJpoUDs0y2VEwQUYfqSAgEavONVJR3L/oPd0asmIVib5Jpd491rps3F3USPjjWkhe1EX1C5sQe/m/w1S9PtfnIvhcmh9WIKFm9grwnzm93yf5AWaxsj6w0LbNagDOt3yy0W9H3z75pNC+tNob7PduS+1mYbCwGy7D6tZRcuA/vrP7C/Nt/IGVTHXfrxI7LTSgacD/zhSezADvz1+nnRt+EWIjj2M7iF6EZztuC6IRd2zjXjqTx+sTCCQQJoRVOR9GkuqWTR6fJxLWwun+OmwmAeDuamR8S96PDUwMlDIVz8ckjSxk+Qr5hrxzOa/+1pshsXzH8feddpBBlfph67cdNpx0KSOZ5SgnOH1JI7R0ZyTZ3FWK6/Z5Xk7kzntrJdg7OxNvSHsfORPavpmOwoI1rD8bFJHm7l2TTZG+akZUz4pO4dYlbLB0hUrB96loVEBlDTYDN6oBPlXMUp3hergTG+xJjxSoXrTTrpupH2+8tPeEuXW3c37964c7eltz8SJu7KTpnzRzewqZTkFyHcS34TqnqsNgwjM5So7irVUvCbMwzmTtTCw6LTuuqWkShzkYV874T774TwpZDgON0ia7mHNDgdu++anT7ej3GQ+Wv0H+ov9UMLyPmx8boAAAAASUVORK5CYII="
          alt=""
        />
      </div>
    </van-popup>
    <div class="enterToCodeBox" v-if="enterToCode">
      <div
        style="
          width: 80%;
          max-width: 4.46rem;
          background: #000;
          padding: 0.5rem 0.42rem;
          border-radius: 0.25rem;
          text-align: center;
          border: 0.02rem solid var(--theme-color-line);
          z-index: 2002;
        "
      >
        <div
          style="
            color: var(--theme-color-line);
            font-size: 0.38rem;
            text-align: center;
            font-weight: bold;
          "
        >
          {{ $t('Login.newText4') }}
        </div>
        <div
          style="
            color: #888;
            font-size: 0.22rem;
            margin-top: 15px;
            line-height: 1.4;
          "
        >
          {{ $t('Login.newText5') }} <br /><span style="color: #fff"
            >{{ country.code }} {{ formConter.phone }}</span
          >
        </div>
        <div
          style="
            display: flex;
            justify-content: center;
            gap: 0.15rem;
            margin: 0.35rem 0;
          "
        >
          <div class="code-char" v-for="item in codeNum">
            {{ item }}
          </div>
        </div>
        <div
          style="
            width: 100%;
            max-width: 6rem;
            height: 0.92rem;
            background: var(--theme-primary-color) !important;
            border: none;
            border-radius: 0.5rem;
            color: white;
            font-size: 0.3rem;
            font-weight: bold;
            cursor: pointer;
            text-align: center;
            line-height: 0.92rem;
          "
          @click="copyToWhatsApp"
        >
          {{ $t('Login.newText6') }}
        </div>
      </div>
    </div>
    <div class="enterToCodeBox" v-if="isCopyToWhatsApp">
      <div
        style="
          width: 80%;
          max-width: 4.46rem;
          background: #000;
          padding: 0.5rem 0.42rem;
          border-radius: 0.25rem;
          text-align: center;
          border: 0.02rem solid var(--theme-color-line);
          z-index: 2002;
          position: relative;
        "
      >
        <div
          style="
            color: var(--theme-secondary-color-finance);
            font-size: 0.38rem;
            text-align: center;
            font-weight: bold;
          "
        >
          Tips
        </div>
        <div
          style="
            color: #fff;
            font-size: 0.22rem;
            margin-top: 15px;
            line-height: 1.4;
          "
        >
          {{ $t('Login.newText7') }}
        </div>

        <img
          src="../../assets/icons/images/ic-code-tip.png"
          alt=""
          style="
            width: 100%;
            max-width: 4rem;
            border-radius: 10px;
            margin: 0.28rem 0;
            border: 0.02rem solid rgba(255, 255, 255, 0.1);
          "
        />
        <div
          style="
            color: var(--theme-color-line);
            font-size: 0.22rem;
            font-weight: bold;
            margin-bottom: 0.1rem;
          "
        >
          {{ $t('Login.newText8') }}
        </div>
        <div
          style="
            background: rgba(255, 255, 255, 0.05);
            border: 0.02rem dashed var(--theme-color-line);
            padding: 0.18rem;
            margin: 0.25rem 0;
            border-radius: 0.14rem;
            font-size: 0.21rem;
            color: #888;
          "
        >
          <span> {{ $t('Login.newText9') }}</span>
          <span
            style="
              color: #fff;
              font-weight: bold;
              font-size: 0.32rem;
              letter-spacing: 0.04rem;
              margin-left: 0.1rem;
            "
            >{{ codeNum }}</span
          >
        </div>
        <div>
          <van-button
            type="default"
            style="
              width: 100%;
              max-width: 6rem;
              height: 0.92rem;
              border: none;
              border-radius: 0.5rem;
              color: white;
              font-size: 0.3rem;
              font-weight: bold;
              cursor: pointer;
              text-align: center;
              line-height: 0.92rem;
              margin-top: 0.61rem;
              transition: all 0.3s ease;
              line-height: 1;
            "
            color="var(--theme-primary-color)"
            :disabled="isDisabled"
            @click="toTry"
            >{{
              !isDisabled
                ? countNum >= 4
                  ? $t('Login.newText17')
                  : $t('Login.newText10')
                : overTime + 'S'
            }}</van-button
          >
        </div>
        <div
          style="
            position: absolute;
            top: 0.25rem;
            right: 0.25rem;
            width: 0.5rem;
            height: 0.5rem;
            background: rgba(255, 255, 255, 0.1);
            border: none;
            border-radius: 50%;
            color: #fff;
            font-size: 0.4rem;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.3s ease;
          "
          @click="close"
        >
          ×
        </div>
      </div>
    </div>
    <div class="password-box" v-if="toEnterPassWord">
      <div
        style="
          border: 0.035rem solid var(--theme-color-line);
          background-color: var(--theme-main-bg-color);
          border-radius: 0.28rem;
          padding: 0.42rem 0.35rem;
          box-sizing: border-box;
          width: 100%;
          max-width: 9.33rem;
        "
      >
        <div
          style="
            font-size: 0.35rem !important;
            color: #fff !important;
            display: block;
            margin-bottom: 0.2rem;
            text-align: center;
            font-weight: 700 !important;
          "
        >
          {{ $t('Login.newText13') }}
        </div>
        <div class="spcss" style="margin-bottom: 0.1rem">
          <div
            class="flex items-center"
            style="
              border: 0.02rem solid var(--theme-color-line);
              border-radius: 0.14rem;
              height: 0.84rem;
              overflow: hidden;
            "
          >
            <div style="width: 100%">
              <van-field
                v-model="formConter.password"
                label=""
                :placeholder="$t('Login.newText14')"
              />
            </div>
          </div>
          <div
            class="ant-select-dropdow"
            @click.stop="riqifanshi = false"
            v-if="riqifanshi"
            style="width: auto"
          >
            <div class="Conter_arrConte" style="width: auto">
              <div
                class="icontest"
                style="
                  display: flex;
                  align-items: center;
                  color: var(--theme-text-color-lighten);
                  width: auto;
                "
              >
                <img
                  style="width: 0.36rem; height: 0.27rem"
                  :src="
                    require('./../../assets/icons/images/' +
                      country.name +
                      '.png')
                  "
                />
                <span style="padding-left: 0.1rem; padding-right: 0.4rem">{{
                  country.full
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style="
          width: 100%;
          max-width: 9.33rem;
          height: 0.92rem;
          background: var(--theme-primary-color) !important;
          border: none;
          border-radius: 0.5rem;
          color: white;
          font-size: 0.3rem;
          font-weight: bold;
          cursor: pointer;
          text-align: center;
          line-height: 0.92rem;
          margin-top: 0.5rem;
        "
        @click="goRegister"
      >
        {{ $t('components._Prosseguir') }}
      </div>
    </div>
    <van-popup
      v-if="$store.state.isRecord && $store.state.isRecordType == 1"
      v-model="showLogin"
      z-index="3000"
      :close-on-click-overlay="false"
    >
      <div class="login-register-body only-login-body">
        <div class="loinLOBox">
          <img
            :src="$store.state.config.reg_page_logo"
            v-lazy="$store.state.config.reg_page_logo"
            loading="loaded"
            class="loinLOfonImg"
            v-if="
              !['#', 'hide', 'show'].includes($store.state.config.reg_page_logo)
            "
          />
          <div
            class="loinTitle"
            v-html="$store.state.config.reg_page_group"
            v-if="$store.state.config.reg_page_group != '#'"
          ></div>
        </div>
        <van-tabs
          v-model="type"
          @click="routerFun"
          class="h"
          lineWidth="23%"
          animated
          line-height=".03rem"
          sticky
          offset-top=".9rem"
          background="var(--theme-main-bg-color)"
          :ellipsis="false"
          title-active-color="var(--theme-primary-color)"
          title-inactive-color="var(--theme-text-color-darken)"
          color="var(--theme-primary-color)"
        >
          <van-tab
            title-style="font-size: 0.26rem;"
            v-for="(item, index) in tabList"
            :title="$t(item.name)"
            :name="index"
            :key="index"
          >
            <template #title>
              <svg-icon
                className="imageWrap"
                style="width: 0.26rem; height: 0.26rem"
                :icon-class="item.icon"
              />
              {{ $t(item.name) }}
            </template>
            <component
              :is="item.content"
              ref="childRef"
              @onLogin="onLogin"
              @changePasswordFun="
                $store.commit('isRecord'), (changePassword = true)
              "
            ></component>
          </van-tab>
        </van-tabs>
        <div
          style="
            position: relative;
            padding: 0 0.3rem;
            width: calc(100% - 0.6rem);
          "
        >
          <div
            class=""
            style="display: flex; align-items: center; padding-bottom: 0.2rem"
          >
            <button
              type="button"
              style="border-radius: 0.14rem"
              @click="loginUrl"
              :class="
                $store.state.config.reg_btn_sf
                  ? 'GaL3XJonIwzK4ZeJyCyq'
                  : 'GaL3XJonIwzK4ZeJyCyq2'
              "
            >
              {{ $t('Login._Login') }}
            </button>
          </div>
          <div
            v-if="
              $store.state.config.register_give &&
              $store.state.isRecordType == 0
            "
            class="uh6csli2MHzFz87__Phx tool-tips r1QnBDk2QnzYN6t7hweu"
            style="
              position: absolute;
              --cu-top: -0.05rem;
              --cu-right: -0.12rem;
              --cu-left: unset;
            "
          >
            <p
              class="tool-tips-box sNgyWmhVEZVrbSGKDBra"
              :style="{
                color: $store.state.config.ui_version == '3.7' ? '#fff' : '#fff'
              }"
            >
              {{ $t('components._Registrar') }} +
              {{ $store.state.config.register_give }}
            </p>
            <p class="tool-tips-tail YiNQnpSJUes7u5sqBZhp"></p>
          </div>
          <ul
            class="footerMensg"
            style="
              display: flex;
              align-items: center;
              color: var(--theme-primary-color);
              font-size: 0.22rem;
              line-height: 0.26rem;
              text-align: center;
            "
            :style="
              $store.state.isRecordType !== 0 ||
              !$store.state.config.category_hide.includes('_Demo')
                ? ''
                : 'justify-content: center;'
            "
          >
            <li
              :style="{
                width:
                  $store.state.isRecordType !== 0
                    ? $store.state.config.category_hide.includes('_Demo')
                      ? ' 50%'
                      : '33.3%'
                    : !$store.state.config.category_hide.includes('_Demo')
                    ? ' 50%'
                    : ''
              }"
              @click="openUrlLofin('notice')"
            >
              {{ $t('Login._Suporteaocliente') }}
            </li>
            <li
              v-if="!$store.state.config.category_hide.includes('_Demo')"
              :style="{
                width: $store.state.isRecordType !== 0 ? '33.3%' : ' 50%'
              }"
              @click="
                openUrlLofin('subgame', {
                  id: '',
                  category: 'demo'
                })
              "
            >
              {{
                !$store.state.config.category_hide.includes('_Demo')
                  ? $t('Login._JogarGrátis')
                  : ''
              }}
            </li>
            <li
              v-if="$store.state.isRecordType !== 0"
              :style="{
                width: $store.state.config.category_hide.includes('_Demo')
                  ? ' 50%'
                  : '33.3%'
              }"
              @click=""
            >
              {{ $t('Login._EsqueceuaSenha') }}
            </li>
          </ul>
          <div
            :class="[
              $store.state.config.ui_version != '3.7' &&
              $store.state.config.show_quick_login
                ? 'footerMensg3_7mens2'
                : 'footerMensg3_7mens'
            ]"
          >
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <div class="footerMensg3_7Login">
                {{ $t('components._LoginRpido') }}
              </div>
            </div>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <img
                v-if="$store.state.config.ui_version == '3.7'"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADyklEQVR4AeyYUVLbMBCGf7VwjsJJcE5C8kw60xsQbtCZhmfoSZKeBHoOmKr6vFZsEttZ1wSGaXaykSKtVvvvrlZ2PumD0xHAewfwGIFjBEZ64JhCIx04evl/HoFv8UzzeK2reLdhxrr8ylxT/mucpvVFl7hn/N8igBHzGPWsh7TJQkHTDT9ppS560nWaquWj7tLvVQL/kIAwl34O+wwDgAevohnd3CfqUdJacNAste2fT/qVJkzO1qSf6RN0JmlRAmEP+WkYgOfkMduMHTBkomUIug3nqaUPM878Lv8I9xs51pzoXHDUvSB090UQmS32AyDPpUJGGAp3G2ty/d/fw6Pg2zBTjhwgSFH5yA8gaCqjtZZhnOGm5+U30ZFMb9RUTvIBoFrUCm/q7qv3TLdFIUe7dxMfgKgvGy2H8H5WfiKKgSq6qNrexgvgrNTSrBzlwCt/cR7yHlG2p/rJB6BPxzwWqfzZRdZWArfHkJ/HVbmmTW9QMwraR0MB2CFrao26TBVkWvJz6jfnMJTLDqPzuF1eRSnfHM/zA1sfgFNxuNYK+jlIf50GrnyudA/ayweA3FyG8XW/srC3oUgs/Xv5APTuOHByYI7v0z4eQE4vaa0TV4pZikgL4W2No/EA6vSaiL72EEZbigBkj/D+6fEAuvbgeYYblfmg3zSH4MMAsAe/RWkwF9NnrXUg8gGgXlPTXz4TdZtkz/0SxgfN5EktVZT32r4Aq+ntxgeAy0oqkkGX8hBPlvV7wlDvX6ctCtnbW+r2f3wAso76YsojdUuEeFsj9+vRuodHSS2TKeqJcT0fgCDf84kdWns1xFhSDkCA45EiaCpkYHVQn5NalvgAtCzcGTrRLKWYAcVAjLXnHg5z0+MLkWI7CqoB1tLN54h+D3sB8DIuoZxDphbioJ5qoqBZml1vwHCQYWkh3n+Xobv+EzFV5KxcPgDNFw3zarXLVgMIvMtFxUt7PsjWvxHz6iErFiawT9ak5AOAMvOsZFGgUuhVybxflDrzXuWP/i8fAHQQUksFftlB7UonJDxMZYI55HVk171nZEuvHwBRIMclq+tEQlqlf9Riert62LB5Uq0EYIyllMJUJpg7hgXmoO4zgswW+wGwEBBUG4nKog0BJvMfXWzGdzukXlGmIfJ53gxfVH+QmYPy3J52GACUAYJKwgGlqpCv/LMGSwvZ47VaCfDIwcgaT5QPeeui/sHhAJr6AEPV4Z81GGCMNWWafeaQg5E1HuTxpjr64wCg4Z35CKA1AG84eIzAGzq7datjBFrd8oaDHz4CfwEAAP//6yWs5gAAAAZJREFUAwCqmF5wE4l6oQAAAABJRU5ErkJggg=="
                class="footerMensg3_7img"
                style="
                  width: 0.7rem;
                  height: 0.7rem;
                  margin: 0 0.2rem;
                  margin-top: 0.2rem;
                "
              />
              <img
                :src="GoogleLOgo"
                class="footerMensg3_7img"
                style="
                  width: 0.7rem;
                  height: 0.7rem;
                  margin: 0 0.2rem;
                  margin-top: 0.2rem;
                "
              />
              <img
                v-if="$store.state.config.ui_version != '3.7'"
                :src="fbLOgo"
                class="footerMensg3_7img"
                style="
                  width: 0.7rem;
                  height: 0.7rem;
                  margin: 0 0.2rem;
                  margin-top: 0.2rem;
                "
              />
              <img
                v-if="$store.state.config.ui_version != '3.7'"
                :src="tgLOgo"
                class="footerMensg3_7img"
                style="
                  width: 0.7rem;
                  height: 0.7rem;
                  margin: 0 0.2rem;
                  margin-top: 0.2rem;
                "
              />
            </div>
          </div>
        </div>
      </div>
      <div class="QzRd3YqTnYxG8Latq8fW" @click="cancelLogin">
        <img
          class="closeIcon"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAMAAABGS8AGAAAAilBMVEUAAAD////e5Orv8vXe5Or////e5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Or////////h5+z8/f7z9ffm6/Dp7fHt8PT5+vv2+PrCEzcDAAAAJXRSTlMAYJYggoAJR6DVzbyRfHYuimpXKBlePTURrlDbxOm27OJwZaif1OMsUAAABGNJREFUWMPdmdtiojAQhlNAOSOoeK6tugRy4P1fb0lCO26DDRiv9r8Twsfkz0wSA/ovtVh6tzj8fP/4eP+M4iBdrpC93GtwJJQ1La+leNswisOgXNtQd9czpg2vNPGG4v1y/iR2lWDaVo9Ud2xv/YyxDmnqnsG77hOCOxFhC/+6znDuTsSuHdx89ZrgU5CW/nbluqutX6ZBJP1RYeN8kiEZZv2DJMr9nfbaZRL2/alZdJ3ignyIU5xvHzXaOJipVsQZaXWBG4UNi99zJuvR7LQcw00Il63xxdw2VTG02DO3dahqmuxG1Y8jw6iJY2g4V1wWH9BIFZEMmjoGLlPv302oI4eayYqLczRJKomoY/CX4wxNVI4F+bHPDpHcAk2Wp8gPcuOChQ/AnURWzx4GByEUiYNT9JQS0ds2HjSiEb1JnoDC+LABmzMCN55SIALDpVb4wn4eWSw4G0k4aR4x8b4rslAq+ky9HyOHlRFWujUiM34ELK9JI2zM0EJewyUbJVrIHuuufNpvQsT40QKB5IVsoOVsNnMRGnEDQuYh/F5S0QV9uX2rhN7QmBuQAwTWyX33osbRw6qU3nSukh5z3Hak/J/iIBut1awC8hC3mmmPlLQfLHDiiAbBQNa51R99CcL1nReOcCIZBgNZ50LEoHPHYl9pIOZLekCDHgNZ54LHoIx1QZ7758VQalUHECBrl3RtCSTYgYh5DSET2cgFkxcQfYDMZANX6dR2vi6/x455aAR5BBcFMHpiIGmJRpDNXDXt9MUW8c4VHxnII7mooN9pEXJZdwaymQvV1qoF6hPG0UQ2c5EPOfbRgfEKmcnANYHDEWAgA9cMBivswboVRzF4W3srYPD4SUs3+8G7iqw4qwJpoUDs0y2VEwQUYfqSAgEavONVJR3L/oPd0asmIVib5Jpd491rps3F3USPjjWkhe1EX1C5sQe/m/w1S9PtfnIvhcmh9WIKFm9grwnzm93yf5AWaxsj6w0LbNagDOt3yy0W9H3z75pNC+tNob7PduS+1mYbCwGy7D6tZRcuA/vrP7C/Nt/IGVTHXfrxI7LTSgacD/zhSezADvz1+nnRt+EWIjj2M7iF6EZztuC6IRd2zjXjqTx+sTCCQQJoRVOR9GkuqWTR6fJxLWwun+OmwmAeDuamR8S96PDUwMlDIVz8ckjSxk+Qr5hrxzOa/+1pshsXzH8feddpBBlfph67cdNpx0KSOZ5SgnOH1JI7R0ZyTZ3FWK6/Z5Xk7kzntrJdg7OxNvSHsfORPavpmOwoI1rD8bFJHm7l2TTZG+akZUz4pO4dYlbLB0hUrB96loVEBlDTYDN6oBPlXMUp3hergTG+xJjxSoXrTTrpupH2+8tPeEuXW3c37964c7eltz8SJu7KTpnzRzewqZTkFyHcS34TqnqsNgwjM5So7irVUvCbMwzmTtTCw6LTuuqWkShzkYV874T774TwpZDgON0ia7mHNDgdu++anT7ej3GQ+Wv0H+ov9UMLyPmx8boAAAAASUVORK5CYII="
          alt=""
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Loading } from 'vant';
import axios from 'axios';
import antInput from './input.vue';
import { Toast } from 'vant';
import { pustRegister } from '@/apis/modules/login.js';
import { login } from '@/apis/modules/login.js';
import loIn from './loIn.vue';
export default {
  components: {
    antInput
  },
  props: {
    isRecord: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      countNum: 0,
      type: 0,
      tabList: [
        {
          name: 'loain._AcessoDeMembro',
          icon: 'login_icon_dl--svgSprite:all',
          content: loIn
        }
      ],
      loading: false,
      toEnterPassWord: false,
      overTime: 10,
      codeNum: '',
      enterToCode: false,
      isCopyToWhatsApp: false,
      isDisabled: false,
      formConter: {
        user_name: '',
        phone: '',
        password: '',
        password_confirm: '',
        cpf: '',
        invite_code: '',
        invite_id: 0,
        real_name: ''
      },
      isFocus: false,
      riqifanshi: false,
      country: { name: 'country', code: '+55', full: 'Brazil（+55）' },
      GoogleLOgo: require('./../../assets/4Ddian/aoffx-gl7s6.png'),
      fbLOgo: require('./../../assets/kuaijiexiaz/Facebook.png'),
      tgLOgo: require('./../../assets/kuaijiexiaz/img_tg.png'),
      iscaptcha_configId: false,
      changePassword: false,
      activeName: 1,
      activeLength: 12,
      loain: {
        _Inscreverse: 'Registro',
        _AcessoDeMembro: 'Login'
      },
      captcha: () => {},
      conTnetfrom: {},
      rememberPassword: []
    };
  },
  computed: {
    showRegister() {
      if (this.$store.state.isRecordType == 0) {
        return true;
      } else {
        return false;
      }
    },
    showLogin() {
      if (this.$store.state.isRecordType == 1) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {
    let _this = this;
    if (_this.$store.state.config.captcha_config.id) {
      this.$initGeetest4(
        {
          captchaId: this.$store.state.config.captcha_config.id,
          product: 'bind',
          language: _this.$store.state.config.captcha_config.language
        },
        function (captcha) {
          _this.captcha = captcha;
          captcha
            .onReady(function () {})
            .onSuccess(function () {
              var result = captcha.getValidate();
              result.captcha_id = _this.$store.state.config.captcha_config.id;
              _this.checkComplete(_this.conTnetfrom);
            })
            .onError(function () {});
          // let co=captcha.showCaptcha();
        }
      );
    } else {
      this.iscaptcha_configId = true;
    }
    if (this.$store.state.config.currency == 'R$') {
      this.country = { name: 'Brazil', code: '+55', full: 'Brazil（+55）' };
    } else if (this.$store.state.config.currency == '$') {
      this.country = { name: 'America', code: '+1', full: 'America（+1）' };
    } else if (this.$store.state.config.currency == '₹') {
      this.country = { name: 'India', code: '+91', full: 'India（+91）' };
    } else if (this.$store.state.config.currency == '¢') {
      this.country = { name: 'Malaysia', code: '+60', full: 'Malaysia（+60）' };
    } else if (this.$store.state.config.currency == 'M$') {
      this.country = { name: 'Mexico', code: '+52', full: 'Mexico（+52）' };
    }
  },
  methods: {
    routerFun(e, l) {
      this.activeLength = l.length;
    },
    loginUrl() {
      try {
        this.$refs.childRef[0].loginUrl();
      } catch (error) {
        this.$refs.childRef[1].loginUrl();
      }
    },
    openUrlLofin(name, quser) {
      this.openUrl(name, quser);
      this.$store.commit('isRecord');
    },
    isRealMobile() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isMobile =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          userAgent
        );
      const isTouchDevice = 'ontouchstart' in document.documentElement;
      const multiTouchPoints =
        navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
      return isMobile && isTouchDevice && multiTouchPoints;
    },
    goRegister() {
      let checked = this.validatePassword(this.formConter.password);
      if (checked) {
        this.formConter.password_confirm = this.formConter.password;
        let inviteId = null;
        let inviteLink =
          window.document.documentElement.getAttribute('data-initLink');
        let strictId =
          window.document.documentElement.getAttribute('data-inviteId');
        if (
          this.$store.state.config.strict_invite ||
          (this.$store.state.config.strict_sale &&
            Number(strictId) < 100000000 &&
            Number(strictId) > 10000000)
        ) {
          inviteId = strictId;
        }
        inviteId = window.localStorage.getItem('inviteID') || inviteId;
        if (this.$store.state.config.ui_version == '3.4') {
          inviteId = this.formConter.invite_code;
        }
        pustRegister({
          ...this.formConter,
          invite_id: inviteId,
          invite_link: window.localStorage.getItem('initLink') || inviteLink,
          invite_code: window.localStorage.getItem('inviteID') || strictId,
          is_mobile: this.isRealMobile() ? 1 : 0
        }).then(({ data, msg, code }) => {
          this.toEnterPassWord = false;
          if (code == 0) {
            // this.isLOding
            this.$store.commit('sLoading', true);
            this.onLogin(
              {
                password: this.formConter.password,
                account: this.formConter.user_name || this.formConter.phone,
                isZhuzhe: true
              },
              this.rememberPasswordC
            );
            this.$store.commit('sLoading', false);
            if (!this.$store.state.config.register_pop) {
              if (
                !this.$store.state.config.hideAppDownload &&
                this.$store.state.config.download_give[0] == 'y'
              ) {
                setTimeout(() => {
                  this.$store.commit('publicFun', ['AppDownload', true]);
                }, 1000);
              }
            } else {
              window.localStorage.setItem(
                'CancelDisplay',
                this.$store.state.config.register_pop
              );
            }
          } else {
            // Toast(msg);
            this.formConter = {
              user_name: '',
              phone: '',
              password: '',
              password_confirm: '',
              cpf: '',
              invite_code: '',
              invite_id: 0,
              real_name: ''
            };
            Toast.fail({
              message: this.myLineBreaks(msg),
              duration: 1000
            });
          }
        });
      }
    },
    validatePassword(password) {
      let _this = this;
      if (password.length < 6) {
        Toast.fail({
          message: _this.$t('Login.newText15'),
          duration: 1000
        });
        return false; // 密码长度必须为6位
      }
      // 定义正则表达式来检查不同的字符类型
      const hasDigit = /\d/.test(password);
      const hasLower = /[a-z]/.test(password);
      const hasUpper = /[A-Z]/.test(password);
      const hasSpecial = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password); // 定义一些常见的特殊字符
      // 计算不同类型的字符数（这里实际上只关心是否存在，所以是布尔值）
      let typeCount = 1;
      if (hasDigit) typeCount++;
      if (hasLower) typeCount++;
      if (hasUpper) typeCount++;
      if (hasSpecial) typeCount++;
      // 检查是否至少有两种字符类型
      if (typeCount >= (this.$store.state.config.ui_version == '3.4' ? 1 : 2)) {
        return true;
      } else {
        Toast.fail({
          message: _this.$t('Login.newText16'),
          duration: 1000
        });
        return false;
      }
    },
    close() {
      this.isCopyToWhatsApp = false;
      this.isDisabled = false;
      this.overTime = 10;
    },
    toTry() {
      this.countNum++;
      let _this = this;
      if (this.countNum > 4) {
        Toast.fail({
          message: _this.$t('Login.newText18'),
          duration: 1000
        });
        this.isCopyToWhatsApp = false;
        this.countNum = 0;
        return;
      }
      this.loading = true;
      axios
        .get(
          this.$store.state.config.bind_url+'?type=2&tel='+this.formConter.phone
        )
        .then(response => {
          if (response.data !== 'true') {
            setTimeout(() => {
              this.loading = false;
              if (this.countNum < 4) {
                this.isDisabled = true;
                this.retry();
              }
            }, 3000);
          } else {
            this.loading = false;
            //绑定了就去输入密码
            this.$store.commit('isRecord');
            this.close();
            this.toEnterPassWord = true;
          }
        })
        .catch(error => {
          this.loading = false;
          //console.error('Error loading manifest:', error);
        });
    },
    retry() {
      if (this.isDisabled) {
        setTimeout(() => {
          this.overTime--;
          if (this.overTime !== 0) {
            this.retry();
          } else {
            setTimeout(() => {
              this.overTime = 10;
              this.isDisabled = false;
            }, 500);
          }
        }, 1000);
      }
    },
    copyToWhatsApp() {
      this.enterToCode = false;
      this.isCopyToWhatsApp = true;
      this.toTry();
    },
    submit() {
      let _this = this;
      if (
        !this.formConter.phone ||
        this.formConter.phone.length <= 9 ||
        this.formConter.phone.length > 11
      ) {
        Toast.fail({
          message: _this.$t('Login.newText12'),
          duration: 1000
        });
      } else {
        this.loading = true;
        axios
          .get(
            this.$store.state.config.bind_url+'?type=1&tel='+this.formConter.phone
          )
          .then(response => {
            if (response.data.success) {
              this.codeNum = response.data.code;
              this.loading = false;
              this.enterToCode = true;
            } else {
              this.loading = false;
            }
          })
          .catch(error => {
            this.loading = false;
            //console.error('Error loading manifest:', error);
          });
      }
    },
    cancelLogin() {
      this.$store.commit('isRecord');
      if (this.$store.state.isRefreshLoading) {
        setTimeout(() => {
          let alwaysShowDownload =
            this.$store.state.config.always_show_download;
          if (
            alwaysShowDownload &&
            !this.$store.state.config.hideAppDownload &&
            this.$store.state.config.download_give[0] == 'y'
          ) {
            this.$store.commit('publicFun', ['AppDownload', true]);
          } else {
            let inviteTime = localStorage.getItem('inviteTime');
            if (inviteTime) {
              if (inviteTime > new Date().getTime()) {
                this.$store.commit('publicFun', ['isCancelDisplay', false]);
              } else {
                this.$store.commit('publicFun', ['isCancelDisplay', true]);
              }
            } else {
              this.$store.commit('publicFun', ['isCancelDisplay', true]);
            }
            if (!this.$store.state.popList.length)
              this.$store.commit('publicFun', ['isCancelDisplay', false]);
            if (
              !this.$store.state.isCancelDisplay &&
              this.$store.state.first_recharge.status == 'show'
            ) {
              let isRechargeGiftTime =
                localStorage.getItem('isRechargeGiftTime');
              let isRechargeGift = localStorage.getItem('isRechargeGift');
              if (!isRechargeGift && !isRechargeGiftTime)
                this.$store.commit('publicFun', ['isRechargeGift', true]);
            }
          }
        }, 500);
      }
    },
    onLogin(from = {}, rememberPassword) {
      if (from.account) {
        if (
          this.$store.state.config.register_type != 'name' &&
          /^\d+$/.test(from.account) &&
          from.account.length >= 10 &&
          from.account.length <= 11
        ) {
          from.type = 1;
        } else {
          from.type = 2;
        }
      }
      if (rememberPassword) {
        rememberPassword.unshift(from);
        this.rememberPassword = rememberPassword;
      }
      this.conTnetfrom = from;
      if (from.isZhuzhe) {
        this.rememberPassword = rememberPassword;
        this.checkComplete(from, rememberPassword);
        return false;
      }
      if (!this.iscaptcha_configId) {
        this.captcha.showCaptcha();
      } else {
        this.checkComplete(this.conTnetfrom);
      }
      this.formConter = {
        user_name: '',
        phone: '',
        password: '',
        password_confirm: '',
        cpf: '',
        invite_code: '',
        invite_id: 0,
        real_name: ''
      };
    },
    checkComplete(from = {}, rememberPassword) {
      login(from).then(({ code, data, msg }) => {
        if (code == 0) {
          this.$vuex('vuex_token_head', data);
          this.$vuex('vuex_token', data.token);
          this.$store.commit('isRecord');
          window.localStorage.setItem(
            'rememberPassword',
            JSON.stringify(this.rememberPassword)
          );
          // _this.$router.push({name:'home'});
          location.reload();
        } else {
          Toast.loading({
            message: this.myLineBreaks(msg),
            duration: 1000
          });
          // Toast.loading({

          // setTimeout(()=>{
          // 	Toast.clear()
          // },1000)
          return false;
          // })
        }
      });
    }
  }
};
</script>
<style>
.spcss input::-webkit-input-placeholder {
  /* 使用webkit内核的浏览器 */
  font-size: 0.28rem !important;
}

.spcss input:-moz-placeholder {
  /* Firefox版本4-18 */
  font-size: 0.28rem !important;
}

.spcss input::-moz-placeholder {
  /* Firefox版本19+ */
  font-size: 0.28rem !important;
}

.spcss input:-ms-input-placeholder {
  /* IE浏览器 */
  font-size: 0.28rem !important;
}
.loinTitle {
  font-size: 0.32rem;
}
.loinLOBox {
  text-align: center;
  color: var(--theme-primary-color);
  margin-top: 0.2rem;
}
.loinLOfonImg {
  height: 0.8rem;
}
.login-body .van-field__body input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.login-body {
  font-weight: 400;
  .loading {
    width: 100dvw;
    height: 100dvh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 5000;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.login-body .van-popup {
  background-color: transparent;
}
.login-body .van-tab--active .imageWrap {
  color: var(--theme-primary-color) !important;
}
.login-register-body .ant-select-dropdow {
  background-color: var(--theme-main-bg-color);
  border: 0.01rem solid var(--theme-color-line) !important;
  border-radius: 0.1rem;
  -webkit-box-shadow: 0 0.03rem 0.09rem 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.03rem 0.09rem 0 rgba(0, 0, 0, 0.1);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  z-index: 999;
  max-height: 2.75rem !important;
  overflow: hidden;
  border-radius: 0.14rem;
  width: 5rem;
  margin-top: 0.01rem;
  padding: 0.14rem 0;
}

.login-register-body .Conter_arrConte {
  display: flex;
  align-items: center;

  color: var(--theme-text-color-lighten);
  justify-content: space-between;
  font-weight: 400;
  font-size: 0.24rem;
  font-size: 0.24rem;
  line-height: 0.8rem;
  min-height: 0.8rem;
  padding: 0px 0.2rem;
}

.login-register-body .Conter_arrConte.active {
  color: var(--theme-primary-color);
}

/* color: var(--theme-primary-color); */
.login-register-body .Conter_arrConte .tengAr {
  color: var(--theme-secondary-color-error);
  font-size: 0.24rem;
}
.login-register-body .van-field__body {
  font-size: 0.22rem;
  margin-left: 0.1rem;
}
.login-register-body ul li {
  cursor: pointer;
}
html .login-register-body .van-tab__text {
  font-size: 0.26rem !important;
}
html .login-register-body .van-field__right-icon > div {
  display: flex;
  align-items: center;
}
.van-toast.van-toast--middle {
  z-index: 99999 !important;
}
.van-tabs--line .van-tabs__wrap {
  height: 0.84rem !important;
}
.csapp37 .footerMensg {
  display: none !important;
}
.footerMensg3_7 {
  display: none !important;
}
.csapp37 .footerMensg3_7 {
  display: flex !important;
}
.footerMensg3_7 {
  display: none;
}
.footerMensg3_7mens {
  display: none;
}
.footerMensg3_7mens2 {
  display: block;
  position: relative;
  padding-top: 0.2rem;
  color: var(--theme-text-color-lighten);
  font-size: 0.22rem;
}
.csapp37 .footerMensg3_7mens {
  display: block;
  position: relative;
  padding-top: 0.2rem;
  color: var(--skin__neutral_2);
  font-size: 0.22rem;
}

.csapp37 .footerMensg3_7img {
  width: 0.4663rem;
  height: auto;
  margin: 0.045rem 0.1rem 0.04rem;
  -webkit-box-shadow: 0 0.03rem 0.07rem 0 #00d9ff;
  box-shadow: 0 0.03rem 0.07rem 0 #00d9ff;
  border-radius: 100%;
}

.footerMensg3_7Login {
  position: relative;
  padding: 0 0.9rem;
}
.footerMensg3_7Login:before,
.footerMensg3_7Login:after {
  position: absolute;
  top: 50%;
  width: 0.7rem;
  height: 0.01rem;
  background-color: var(--theme-color-line);
  transform: translateY(-50%);
  content: '';
}
.footerMensg3_7Login:before {
  left: 0;
}
.footerMensg3_7Login:after {
  right: 0;
}
.spcss {
  .input-active {
    border-color: var(--theme-color-line) !important;
  }
}
</style>
<style scoped>
:deep(.van-cell) {
  background: transparent;
}
:deep(.van-tabs) {
  width: 100%;
}
.only-register {
  width: 100%;
}
.code-char {
  width: 32px;
  height: 42px;
  border: 1px solid var(--theme-color-line);
  border-radius: 6px;
  background: rgba(0, 210, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.38rem;
  font-weight: bold;
  color: #fff;
  text-shadow: 0 0 5px var(--theme-color-line);
}
.enterToCodeBox {
  width: 100dvw;
  height: 100dvh;
  background-color: rgba(0, 0, 0, 0.9);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 4000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.password-box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 4000;
  height: 100dvh;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0.35rem;
}
:deep(.van-field__control) {
  font-size: 0.28rem;
}
.ZEcfoKF3Q_zq5EqaOdUy {
  color: var(--theme-secondary-color-error);
  display: flex;
  align-items: center;
  margin-left: 0.02rem;
  position: relative;
  padding-right: 0.09rem;
}
.ZEcfoKF3Q_zq5EqaOdUy i {
  position: absolute;
  /* top: -.01rem; */
}
:deep(.van-overlay) {
  width: 100dvw;
  max-width: 100dvw !important;
  left: 0 !important;
}
.GaL3XJonIwzK4ZeJyCyq2 {
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
  color: rgba(0, 0, 0, 0.65);
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  height: 32px;
  line-height: 1.499;
  padding: 0 15px;
  position: relative;
  text-align: center;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap;
}
.GaL3XJonIwzK4ZeJyCyq2 {
  background-color: var(--theme-primary-color);
  border-color: var(--theme-primary-color);
  font-size: 0.24rem;
  height: 0.7rem;
  width: 100%;
  color: var(--theme-primary-font-color);
  text-shadow: none;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}

.GaL3XJonIwzK4ZeJyCyq {
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
  color: rgba(0, 0, 0, 0.65);
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  height: 32px;
  line-height: 1.499;
  padding: 0 15px;
  position: relative;
  text-align: center;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap;
}
.GaL3XJonIwzK4ZeJyCyq {
  background-color: var(--theme-primary-color);
  border-color: var(--theme-primary-color);
  font-size: 0.24rem;
  height: 0.7rem;
  width: 100%;
  color: var(--theme-primary-font-color);
  text-shadow: none;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
  animation: _scale-btn-data 1.5s infinite;
  transition: inherit;
}
.GaL3XJonIwzK4ZeJyCyq::after {
  content: '';
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 0.14rem;
  animation: _pulse-green-data 1.5s infinite;
  transition: inherit;
}
@keyframes _pulse-green-data {
  0% {
    box-shadow: 0 0 0 0
      var(--submit-pulse-shadow-start, var(--theme-primary-color));
  }

  70% {
    box-shadow: 0 0 0 0.3rem
      var(--submit-pulse-shadow-end, rgba(0, 255, 102, 0));
  }

  100% {
    box-shadow: 0 0 0 0 var(--submit-pulse-shadow-end, rgba(0, 255, 102, 0));
  }
}
@keyframes _scale-btn-data {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.08);
    transform: scale(1.08);
  }

  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

.uh6csli2MHzFz87__Phx {
  height: 0.32rem;
  left: var(--cu-left);
  position: relative;
  right: var(--cu-right);
  top: var(--cu-top);
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  z-index: 100;
}
.r1QnBDk2QnzYN6t7hweu {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  animation: _scale-btn-data 1.5s infinite;
  transition: inherit;
  overflow: visible;
}
.uh6csli2MHzFz87__Phx .sNgyWmhVEZVrbSGKDBra {
  background-color: var(--theme-secondary-color-error);
  border-radius: 0.1rem 0.1rem 0.1rem 0;
  color: var(--theme-primary-color);
  font-size: 0.16rem;
  height: 0.22rem;
  line-height: 0.22rem;
  padding: 0 0.05rem;
}

.uh6csli2MHzFz87__Phx .sNgyWmhVEZVrbSGKDBra::after {
  content: '';
  width: 100%;
  height: 0.22rem;
  position: absolute;
  top: 0;
  left: 0;
  animation: _pulse-green-two-data 1.5s infinite;
  transition: inherit;
  border-radius: 0.1rem;
}
@keyframes _pulse-green-two-data {
  0% {
    box-shadow: 0 0 0 0
      var(--submit-pulse-shadow-start, var(--theme-secondary-color-error));
  }

  70% {
    box-shadow: 0 0 0 0.15rem
      var(--submit-pulse-shadow-end, rgba(0, 255, 102, 0));
  }

  100% {
    box-shadow: 0 0 0 0 var(--submit-pulse-shadow-end, rgba(0, 255, 102, 0));
  }
}
.uh6csli2MHzFz87__Phx .YiNQnpSJUes7u5sqBZhp {
  border-bottom: 0.07rem solid transparent;
  border-left: 0.07rem solid var(--theme-secondary-color-error);
  border-right: 0.07rem solid transparent;
  height: 0;
  width: 0;
}

.login-register-body {
  border: none;
  max-height: calc(100vh - 0.1rem);
  position: static;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  max-height: calc(100vh - 2.4rem);
  padding: 0.35rem;
  overflow: visible;
  color: #fff;
  align-items: center;
}

.only-login-body {
  background-color: var(--theme-main-bg-color);
  border: thin solid;
  border-color: var(--theme-color-line);
  border-radius: 0.2rem;
  max-height: calc(100vh - 0.1rem);
  overflow: auto;
  width: 6.9rem;
  position: static;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  max-height: calc(100vh - 2.4rem);
  padding: 0 0 0.2rem 0;
  overflow: visible;
}
.login-box {
  border: 0.035rem solid var(--theme-color-line);
  background-color: var(--theme-main-bg-color);
  border-radius: 0.28rem;
  padding: 0.42rem 0.35rem;
  box-sizing: border-box;
  margin-bottom: 0.35rem;
  width: 100%;
  max-width: 9.33rem;
}
.login-body .imageWrap {
  color: var(--theme-text-color-lighten);
}
.QzRd3YqTnYxG8Latq8fW {
  -ms-flex-align: center;
  -ms-flex-pack: center;
  align-items: center;
  background: none;
  border-radius: 50%;
  bottom: -0.88rem;
  display: -ms-flexbox;
  display: flex;
  height: 0.64rem;
  justify-content: center;
  margin-right: -0.3rem;
  position: absolute;
  right: 50%;
  top: auto;
  width: 0.64rem;
  cursor: pointer;
}
.QzRd3YqTnYxG8Latq8fW .closeIcon {
  width: 100%;
  height: 100%;
}
</style>
